var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDesktopView)?_c('ArticleDesktop',{attrs:{"id":_vm.id}}):_vm._e(),(_vm.isMobileView)?_c('ArticleMobile',{attrs:{"id":_vm.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }